export type CorrectionCancelPlan = 'close_without_record' | 'confirm_discard';
export type CorrectionDiscardChoice = 'discard' | 'keep_editing';
export type CorrectionDiscardResolution = 'discard_draft' | 'remain_editing';

/**
 * Unsaved correction editor: Cancel must not call create.
 * Saved draft: Cancel must prompt before discard_journal_amendment.
 */
export function planCorrectionCancel(hasPersistedDraft: boolean): CorrectionCancelPlan {
  return hasPersistedDraft ? 'confirm_discard' : 'close_without_record';
}

export function resolveCorrectionDiscardPrompt(
  choice: CorrectionDiscardChoice,
): CorrectionDiscardResolution {
  switch (choice) {
    case 'keep_editing':
      return 'remain_editing';
    case 'discard':
      return 'discard_draft';
    default: {
      const _exhaustive: never = choice;
      return _exhaustive;
    }
  }
}

export function isCorrectionMutable(row: {
  finalized_at: string | null;
  discarded_at: string | null;
}): boolean {
  return row.finalized_at == null && row.discarded_at == null;
}
